import { OrderLanguageMap, OrderI18nTemplate } from './orderTypes';

type OrderUiShared = Pick<OrderI18nTemplate['ui'], 'common' | 'actions' | 'dialogs' | 'fees' | 'errors' | 'form'>;

export const orderUiSharedTemplate: OrderLanguageMap<OrderUiShared> = {
  zh: {
    common: {
      back: '返回',
      backToOrderList: '返回订单列表',
      pending: '待生成',
      orderNumber: '订单号',
      createdAt: '创建时间',
      packageCount: '包裹数量',
      recipientInformation: '收货人信息',
      packageInformation: '货物信息',
      shippingInformation: '快递信息',
      shippingPrice: '快递价格',
      labelInformation: '面单信息：',
      orderIdWithColon: '订单号：',
      currentStatusWithColon: '当前状态：',
      contact: '联系人',
      phone: '联系电话',
      deliveryAddress: '收货地址',
      ecommerceOrderNumber: '电商订单号',
      packageDimensions: '货物尺寸',
      packageWeight: '货物重量',
      carrier: '快递公司',
      carrierWithColon: '快递公司：',
      trackingNumber: '快递单号',
      shippingPricePendingReview: '快递价格（待复核）',
      baseRate: '基础运费',
      surcharge: '附加费',
      peakSeasonSurcharge: '旺季附加费',
      fuelSurcharge: '燃油附加费',
      insuranceFee: '保险费',
      finalPrice: '最终价格',
      originalAmountWithColon: '原始金额：',
      notProvided: '未提供',
      unknownRecipient: '未知收件人',
      noteWithColon: '注意：',
    },
    actions: {
      cancelPackage: '取消包裹',
      cancelLabel: '取消面单',
      reviewRefund: '审核退款申请',
      cancelOrder: '撤销该订单',
      requestRefund: '申请退款',
      confirmCancel: '确认撤销',
      confirmRefund: '确认退款',
    },
    dialogs: {
      confirmLabelCancellation: '确认撤销面单',
      confirmLabelCancellationMessage: '确定要取消这个面单吗？此操作不可撤销。',
      afterCancellingLabel: '取消该面单后：',
      labelCannotBeRestored: '该面单将无法恢复',
      orderMustBeRecreated: '订单将无法完成支付，需要重新创建订单',
      confirmOrderCancellation: '确认撤销订单',
      confirmRefundRequest: '确认申请退款',
      confirmOrderCancellationMessage: '确定要取消这个订单吗？此操作不可撤销。',
      confirmRefundRequestMessage: '确定要申请退款吗？此操作不可撤销。',
      orderInformation: '订单信息：',
      packageCountWithColon: '包裹数量：',
      totalAmountWithColon: '总金额：',
      afterCancellingOrder: '取消该订单后：',
      orderCannotBeRestored: '该订单将无法恢复',
      needCreateNewOrder: '需要重新创建订单',
      refundRequestedReview: '用户已申请退款，等待审核',
      confirmRefundRequestMessageForAdmin: '用户已申请退款，请审核退款金额',
      uspsCancelFeeNote: '注意：USPS面单取消将收取10%手续费',
      uspsRefundFeeNote: '注意：USPS面单退款将收取10%手续费',
      fullRefundNoteSuffix: '面单将全额退款',
      refundAmountFormula90: '退款金额 = 原金额 × 90%',
      estimatedCreditedAmount90: '预计到账金额 = 退款金额 × 90%',
      estimatedCreditedAmountFull: '预计到账金额 = 退款金额 (全额退款)',
      refundReviewApproved: '退款审核成功',
      labelCancelledSuccessfully: '面单已成功取消',
    },
    fees: {
      residentialSurcharge: '住宅附加费',
      signatureFee: '签名费',
      batterySurcharge: '电池附加费',
      oversizeSurcharge: '超大件附加费',
      additionalHandlingFee: '额外处理费',
      remoteAreaSurcharge: '偏远地区附加费',
      alaskaHawaiiSurcharge: '阿拉斯加/夏威夷附加费',
      dimensionNoncomplianceFee: '尺寸不合规费',
      nonstandardLengthSurcharge: '非标准长度附加费',
      nonstandardVolumeSurcharge: '非标准体积附加费',
      unshippablePenalty: '无法运输罚款',
      dimensionHandlingFee: '尺寸处理费',
      weightHandlingFee: '重量处理费',
      largePackageSurcharge: '大件包裹附加费',
      deliveryAreaSurcharge: '派送区域附加费',
      overMaximumSurcharge: '超限附加费',
      oversizeOverweightSurcharge: '超大/超重附加费',
      overlengthSurcharge: '超长附加费',
      oversizedSurcharge: '超大件附加费',
      overweightSurcharge: '超重附加费',
    },
    errors: {
      orderIdOrPackageIdMissing: '订单ID或包裹ID不存在',
      packageNotFound: '包裹不存在',
      packageDataMissing: '包裹数据不存在',
      loadOrderDetailFailed: '加载订单详情失败',
      loginRequired: '请登录以访问此功能',
      orderOrPackageNotFound: '订单或包裹不存在',
      cancelLabelFailed: '取消面单失败',
      cancelLabelFailedRetry: '取消面单失败，请稍后重试',
      refundReviewFailed: '退款审核失败',
      refundReviewFailedRetry: '退款审核失败，请稍后重试',
    },
    form: {
      refundAmount: '退款金额',
      enterRefundAmount: '输入退款金额',
      reviewNotes: '审核备注',
      enterReviewNotes: '输入审核备注',
    },
  },
  en: {
    common: {
      back: 'Back',
      backToOrderList: 'Back to Order List',
      pending: 'Pending',
      orderNumber: 'Order Number',
      createdAt: 'Created At',
      packageCount: 'Packages',
      recipientInformation: 'Recipient Information',
      packageInformation: 'Package Information',
      shippingInformation: 'Shipping Information',
      shippingPrice: 'Shipping Price',
      labelInformation: 'Label information:',
      orderIdWithColon: 'Order ID:',
      currentStatusWithColon: 'Current status:',
      contact: 'Contact',
      phone: 'Phone',
      deliveryAddress: 'Delivery Address',
      ecommerceOrderNumber: 'E-commerce Order Number',
      packageDimensions: 'Package Dimensions',
      packageWeight: 'Package Weight',
      carrier: 'Carrier',
      carrierWithColon: 'Carrier:',
      trackingNumber: 'Tracking Number',
      shippingPricePendingReview: 'Shipping Price (Pending Review)',
      baseRate: 'Base Rate',
      surcharge: 'Surcharge',
      peakSeasonSurcharge: 'Peak Season Surcharge',
      fuelSurcharge: 'Fuel Surcharge',
      insuranceFee: 'Insurance Fee',
      finalPrice: 'Final Price',
      originalAmountWithColon: 'Original amount:',
      notProvided: 'Not provided',
      unknownRecipient: 'Unknown Recipient',
      noteWithColon: 'Note: ',
    },
    actions: {
      cancelPackage: 'Cancel Package',
      cancelLabel: 'Cancel Label',
      reviewRefund: 'Review Refund',
      cancelOrder: 'Cancel Order',
      requestRefund: 'Request Refund',
      confirmCancel: 'Confirm Cancel',
      confirmRefund: 'Confirm Refund',
    },
    dialogs: {
      confirmLabelCancellation: 'Confirm Label Cancellation',
      confirmLabelCancellationMessage: 'Are you sure you want to cancel this label? This action cannot be undone.',
      afterCancellingLabel: 'After cancelling this label:',
      labelCannotBeRestored: 'This label cannot be restored',
      orderMustBeRecreated: 'This order cannot be paid and must be recreated',
      confirmOrderCancellation: 'Confirm Order Cancellation',
      confirmRefundRequest: 'Confirm Refund Request',
      confirmOrderCancellationMessage: 'Are you sure you want to cancel this order? This cannot be undone.',
      confirmRefundRequestMessage: 'Are you sure you want to request a refund? This cannot be undone.',
      orderInformation: 'Order information:',
      packageCountWithColon: 'Package count:',
      totalAmountWithColon: 'Total amount:',
      afterCancellingOrder: 'After cancelling this order:',
      orderCannotBeRestored: 'This order cannot be restored',
      needCreateNewOrder: 'You need to create a new order',
      refundRequestedReview: 'User requested refund, pending review',
      confirmRefundRequestMessageForAdmin: 'User has requested a refund. Please review the refund amount.',
      uspsCancelFeeNote: 'Note: Cancelling USPS labels charges a 10% fee',
      uspsRefundFeeNote: 'Note: USPS refunds charge a 10% fee',
      fullRefundNoteSuffix: ' labels are fully refunded',
      refundAmountFormula90: 'Refund amount = original amount × 90%',
      estimatedCreditedAmount90: 'Estimated credited amount = refund amount × 90%',
      estimatedCreditedAmountFull: 'Estimated credited amount = refund amount (full refund)',
      refundReviewApproved: 'Refund approved successfully',
      labelCancelledSuccessfully: 'Label cancelled successfully',
    },
    fees: {
      residentialSurcharge: 'Residential Surcharge',
      signatureFee: 'Signature Fee',
      batterySurcharge: 'Battery Surcharge',
      oversizeSurcharge: 'Oversize Surcharge',
      additionalHandlingFee: 'Additional Handling Fee',
      remoteAreaSurcharge: 'Remote Area Surcharge',
      alaskaHawaiiSurcharge: 'Alaska/Hawaii Surcharge',
      dimensionNoncomplianceFee: 'Dimension Noncompliance Fee',
      nonstandardLengthSurcharge: 'Nonstandard Length Surcharge',
      nonstandardVolumeSurcharge: 'Nonstandard Volume Surcharge',
      unshippablePenalty: 'Unshippable Penalty',
      dimensionHandlingFee: 'Dimension Handling Fee',
      weightHandlingFee: 'Weight Handling Fee',
      largePackageSurcharge: 'Large Package Surcharge',
      deliveryAreaSurcharge: 'Delivery Area Surcharge',
      overMaximumSurcharge: 'Over Maximum Surcharge',
      oversizeOverweightSurcharge: 'Oversize/Overweight Surcharge',
      overlengthSurcharge: 'Overlength Surcharge',
      oversizedSurcharge: 'Oversized Surcharge',
      overweightSurcharge: 'Overweight Surcharge',
    },
    errors: {
      orderIdOrPackageIdMissing: 'Order ID or package ID does not exist',
      packageNotFound: 'Package not found',
      packageDataMissing: 'Package data does not exist',
      loadOrderDetailFailed: 'Failed to load order details',
      loginRequired: 'Please log in to access this feature',
      orderOrPackageNotFound: 'Order or package not found',
      cancelLabelFailed: 'Failed to cancel label',
      cancelLabelFailedRetry: 'Failed to cancel label. Please try again.',
      refundReviewFailed: 'Refund review failed',
      refundReviewFailedRetry: 'Refund review failed. Please try again.',
    },
    form: {
      refundAmount: 'Refund Amount',
      enterRefundAmount: 'Enter refund amount',
      reviewNotes: 'Review Notes',
      enterReviewNotes: 'Enter review notes',
    },
  },
};
